import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth, GoogleAuthProvider } from 'firebase/auth'
import { getAnalytics, isSupported as analyticsSupported, type Analytics } from 'firebase/analytics'

let firebaseApp: FirebaseApp | null = null
let auth: Auth | null = null
let analytics: Analytics | null = null

export function initFirebase() {
  if (firebaseApp) return { app: firebaseApp, auth: auth!, analytics }

  // Base config from env
  const config: Record<string, any> = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  }

  // Optional runtime override from Admin Settings (if stored)
  try {
    const runtime = localStorage.getItem('runtime_firebase_settings')
    if (runtime) {
      const parsed = JSON.parse(runtime)
      Object.assign(config, {
        apiKey: parsed.apiKey || config.apiKey,
        authDomain: parsed.authDomain || config.authDomain,
        projectId: parsed.projectId || config.projectId,
        storageBucket: parsed.storageBucket || config.storageBucket,
        messagingSenderId: parsed.messagingSenderId || config.messagingSenderId,
        appId: parsed.appId || config.appId,
        measurementId: parsed.measurementId || config.measurementId,
      })
    }
  } catch (error) {
    console.error('[initFirebase error]', error)
  }

  // Reuse default app if it already exists (initialized elsewhere).
  firebaseApp = getApps().length ? getApp() : initializeApp(config)
  auth = getAuth(firebaseApp)

  // Initialize Analytics only if supported (SSR/HTTP envs may not support)
  analyticsSupported().then((ok) => {
    if (ok) {
      analytics = getAnalytics(firebaseApp!)
    }
  }).catch(() => {})

  return { app: firebaseApp, auth: auth!, analytics }
}

export const googleProvider = new GoogleAuthProvider()


